import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import CardGiftcardOutlined from '@mui/icons-material/CardGiftcardOutlined'
import { EmbargoDetails } from 'types/prize-draw'
import { format } from 'date-fns'

type PrizeAssignedEmbargoProps = {
  item: EmbargoDetails
  marketName: string
}

export const PrizeAssignedEmbargo = ({ item, marketName }: PrizeAssignedEmbargoProps) => {
  const sampleApplication = item.request.application

  const resultWithoutDuplications = item.result.reduce<EmbargoDetails['result'][number][]>(
    (arr, curr) =>
      arr.some(el => el.application?.id === curr.application.id) || curr.application.id === sampleApplication?.id
        ? [...arr]
        : [...arr, curr],
    []
  )

  return (
    <Box width="100%">
      <Typography display="flex" alignItems="center" gap={2} variant="h6" fontWeight={600} mb={2}>
        <CardGiftcardOutlined />
        {`${item.request.prizeGroup.name} ${item.request.prizeGroup.embargoDate ? '( Embargo on ' + format(new Date(item.request.prizeGroup.embargoDate), 'MMM dd, yyyy') + ')' : ''}`}
      </Typography>
      <Grid container>
        <Grid item xs={3}>
          <Typography mb={2} color="gray" fontWeight={500}>
            Total amount
          </Typography>
          <Typography variant="h6" fontWeight={600}>
            {item.count}
          </Typography>
        </Grid>

        {/* <Grid item xs={3}>
          <Typography mb={2} color="gray" fontWeight={500}>
            {t('prize.used')}
          </Typography>
          <Typography variant="h6" fontWeight={600}>
            {item.request.prizeGroup.winners.length}
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography mb={2} color="gray" fontWeight={500}>
            {t('prize.available')}
          </Typography>
          <Typography variant="h6" fontWeight={600}>
            {item.request.prizeGroup.amountLeft}
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography mb={2} color="gray" fontWeight={500}>
            {t('prize.willRemain')}
          </Typography>
          <Typography variant="h6" fontWeight={600}>
            {willRemain}
          </Typography>
        </Grid> */}
      </Grid>

      {item.result !== undefined ? (
        <>
          {/* <Typography variant="h6" fontWeight={600} mt={4}>
            Example applications:
          </Typography> */}
          <Table sx={{ my: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: 'gray' }} component="th">
                  ID
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: 'gray' }} width="100%" component="th">
                  Customer
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: 'gray', minWidth: 160 }} component="th">
                  Status
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: 'gray' }} component="th">
                  Market
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sampleApplication && (
                <TableRow>
                  <TableCell>#{sampleApplication.id}</TableCell>
                  <TableCell>
                    <Typography fontWeight={600} variant="body2" display="block">
                      {sampleApplication.email}
                    </Typography>
                  </TableCell>
                  <TableCell>Prize sent</TableCell>
                  <TableCell>{marketName}</TableCell>
                </TableRow>
              )}
              {resultWithoutDuplications.length > 0 ? (
                resultWithoutDuplications.map((winner, idx) => (
                  <TableRow key={idx}>
                    <TableCell>#{winner.application.id}</TableCell>
                    <TableCell>
                      <Typography fontWeight={600} variant="body2" display="block">
                        {winner.application.email}
                      </Typography>
                    </TableCell>
                    <TableCell>{'-'}</TableCell>
                    <TableCell>{marketName}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>
                    <Typography textAlign="center" fontWeight={600}>
                      No entries
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <Typography variant="h6" px={1}>
            ...
          </Typography>
        </>
      ) : null}
    </Box>
  )
}
